module.exports = __webpack_public_path__ + "assets/fonts/uu5-glyphicons.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/uu5-glyphicons.woff?n7r5pz
// module id = 340
// module chunks = 0